<template>
  <div class="login-container1">
    <el-form autoComplete="on" :model="loginForm" size="default" :rules="loginRules" ref="loginForm"
      class="card-box login-form">
      <h3 class="title">{{ $store.state.sys.title }}</h3>
      <el-tabs type="border-card" style=" border-radius: 9px;">
        <el-tab-pane label="账号密码登录">
          <el-form-item prop="username">
            <el-input name="username" type="text" v-model.trim="loginForm.username" autoComplete="on" placeholder="登录用户名"
              prefix-icon="el-icon-user">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input name="password" :type="pwdType" v-model="loginForm.password"
              autoComplete="off" show-password placeholder="登录密码" prefix-icon="el-icon-lock">
            </el-input>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="" prop="shopid">
                <el-input placeholder="验证码" v-model="code" @keyup.enter.native="handleLogin" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <div class="login-code" style="cursor: pointer" @click="refreshCode">
                <s-identify :identifyCode="identifyCode"></s-identify>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item>
                <el-button type="primary" style="width:100%" :loading="loading" @click.native.prevent="handleLogin">
                  登录
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-button type="primary" style="width:100%" @click.native.prevent="forgetpwd">
                  忘记密码
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="短信验证码登录">
          <el-form autoComplete="on" :model="mobileForm" size="default" :rules="mobileRules" ref="mobileForm">
            <el-form-item prop="mobile">
              <el-input v-model="mobileForm.mobile" type="text" auto-complete="off" placeholder="请输入手机号"
                prefix-icon="el-icon-phone">
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="mobileForm.code" type="text" auto-complete="off" placeholder="短信验证码"
                @keyup.enter.native="mobileLogin">
                <template slot="append">
                  <span v-if="mobileCodeTimer <= 0" @click="getSmsCode" style="cursor: pointer;">获取验证码</span>
                  <span v-if="mobileCodeTimer > 0" class="getMobileCode">{{ mobileCodeTimer
                  }}秒后可重发</span>
                </template>
              </el-input>
            </el-form-item>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item>
                  <el-button type="primary" style="width:100%" :loading="mobileloading"
                    @click.native.prevent="mobileLogin">
                    登录
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <div class="tips">
        Copyright © {{ new Date().getFullYear() }}
        {{ $store.state.sys.company }}
      </div>
      <div class="tips">
        {{ $store.state.sys.info }}
      </div>
    </el-form>

  </div>
</template>

<script>
import Api from "@/api/auth"
import mApi from "@/api/mauth"
import SIdentify from "../components/SIdentity.vue"
import { validatePhone } from "../utils/validators.js"
export default {
  inject: ['reload'],
  name: "login",
  components: { SIdentify },
  data() {
    return {
      mobileCodeTimer: 0,
      loginForm: {
        username: "",
        password: "",
      },
      mobileForm: {
        mobile: "",
        code: ""
      },
      mobileRules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone }
        ],
        code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ]
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入用户名" },
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
      mobileloading: false,
      loading: false,
      pwdType: "password",
      identifyCode: "",
      identifyCodes: "1234567890",
      code: "",
    };
  },
  methods: {
    checkLogin() {
      configApi.getValue("login").then((res) => {
        if (res.data === "off") {
          this.isLogin = false;
        }
      });
    },
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    forgetpwd() {
      this.$router.push('/forgetPassword');
    },
    refreshpage() {
      this.reload();
    },
    handleLogin() {
      if (this.identifyCode !== this.code) {
        this.code = "";
        this.refreshCode();
        this.$message.error({
          showClose: true,
          message: "请输入正确的验证码",
          duration: 2000,
        });
      } else {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$store
              .dispatch("login", this.loginForm)
              .then((res) => {
                //this.loading = false
                this.$router.push({ path: "/" });
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
      // console.log(this.identifyCode);
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },


    //手机号登录
    mobileLogin() {
      this.$refs.mobileForm.validate((valid) => {
        if (valid) {
          this.mobileloading = true
          let params = { mobile: this.mobileForm.mobile, code: this.mobileForm.code }
          mApi.mobilelogin(params)
            .then((res) => {
              console.log(res)
              if (res.code == 0) {
                sessionStorage.setItem("token", res.data)
                this.$message.success("登录成功")
                this.$router.push({ path: "/index" });
              } else {
                this.$message.error(res.message)
                this.mobileloading = false;
              }
            })
        } else {
          return false;
        }
      });
    },

    //获取验证码
    getSmsCode() {
      if (this.mobileCodeTimer <= 0) {
        //手机号校验
        this.$refs.mobileForm.validateField('mobile', (valid) => {
          if (!valid.length) {
            let params = {
              phone: this.mobileForm.mobile
            }
            mApi.mCode(params).then(res => {
              this.$message.success(res.message)
              if (res.code == 0) {
                this.mobileCodeTimer = 120
                let msgTimer = setInterval(() => {
                  this.mobileCodeTimer = this.mobileCodeTimer - 1
                  if (this.mobileCodeTimer <= 0) {
                    clearInterval(msgTimer);
                  }
                }, 1000)
              }
            });
          }
        })
      };
    }
  },
  mounted() {
    this.refreshCode();
  },
};
</script>

<style lang="less">
@bg: #2d3a4b;
@dark_gray: #889aa4;
@light_gray: #eee;

.el-tabs__header {
  border-radius: 9px;
}

.el-tabs__nav-wrap {
  border-radius: 9px;
}

.login-container1 {
  position: fixed;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(135deg, #184e68, #57ca85);

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
  }

  // input {
  //   background: transparent;
  //   border: 0px;
  //   -webkit-appearance: none;
  //   border-radius: 0px;
  //   padding: 12px 5px 12px 15px;
  //   height: 47px;
  // }

  // .el-input {
  //   display: inline-block;
  //   height: 47px;
  //   width: 100%;
  // }

  .tips {
    font-size: 14px;
    color: @light_gray;
    margin-bottom: 10px;
    margin-top: 20px;
    text-align: center;
  }

  .yzmtext {
    font-size: 14px;
    height: 46px;
    text-align: left;
    vertical-align: middle;
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: @dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;

    &_login {
      font-size: 20px;
    }
  }

  .title {
    font-size: 26px;
    font-weight: 400;
    color: @light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }

  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    max-width: 400px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
  }

  .el-form-item {
    border: 0px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
    margin-bottom: 22px;
  }

  .el-form-item__error {
    padding-top: 4px;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: @dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }
}
</style>
